/**
 * Opens the Coach chat socket. The public session token alone identifies the
 * session and every agent in it, so no bot or thread id is sent; one socket
 * serves all the characters.
 */
function createNudgytAgentChatSocket({ base, sessionToken }) {
  if (!base || !sessionToken) {
    console.error(
      '[Nudgyt Agent Chat Socket] Missing required connection params'
    );
    return null;
  }

  const wsBase = base.replace(/^http/, 'ws');
  const wsUrl = `${wsBase}/ws/chat/?session_token=${encodeURIComponent(
    sessionToken
  )}`;

  return new WebSocket(wsUrl);
}

export default createNudgytAgentChatSocket;
